
























































import { defineComponent, reactive, toRefs, onMounted, ref, onBeforeUnmount } from '@vue/composition-api'
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { PracticeFileUpload } from "../../modules/teacher/PracticeFileUploadList"

export interface Data {
  sumup_group_id: string
  practiceFileUploads: PracticeFileUpload[]
  fields: any[]
  errors: string[]
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sumup_group_id: null,
      practiceFileUploads: [],
      fields: [
        {key: "title", label: "表題", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "sort_no", label: "並び順", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "100px"}},
        {key: "is_personal", label: "配布種別", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "150px"}},
        {key: "is_publish", label: "公開", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "80px"}},
        {key: "detail", label: "ファイル一覧", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "130px"}},
        {key: "delete", label: "削除", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "130px"}},
      ],
      errors: [],
    });

    const update = async () => {

      state.errors = [];
      const isPersonalChangedRowNos: number[] = [];

      state.practiceFileUploads.forEach((practiceFileUpload, i) => {
        if(!practiceFileUpload.title){
          state.errors.push(`${i + 1}行目の表題が未入力です。`);
        }

        if(!practiceFileUpload.sort_no){
          state.errors.push(`${i + 1}行目の並び淳が未入力です。`);
        }

        if(practiceFileUpload.id && practiceFileUpload.is_personal != practiceFileUpload.is_personal_cache){
          isPersonalChangedRowNos.push(i + 1);
        }
      });

      if(state.errors.length > 0){
        return;
      }

      if(isPersonalChangedRowNos.length > 0 && !window.confirm(`${isPersonalChangedRowNos.join(',')}行目の配布種別が変更されています。既にアップロード済みのファイルがある場合は削除されます。よろしいですか？`)){
        return;
      }

      if(!window.confirm("保存します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/teacher/practice_file_upload_list/update/${state.sumup_group_id}`, {practice_file_uploads: state.practiceFileUploads}).then(response => {
        alert("処理が完了しました。")
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    const addRecord = () => {
      const practiceFileUpload = new PracticeFileUpload();
      state.practiceFileUploads.push(practiceFileUpload);
    }

    const deleteRecord = (record: PracticeFileUpload) => {
      const idx = state.practiceFileUploads.indexOf(record);
      state.practiceFileUploads.splice(idx, 1);
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      
      await http.get(`/api/teacher/practice_file_upload_list/?sumup_group_id=${state.sumup_group_id}`).then(response => {
        state.practiceFileUploads = response.data.practice_file_uploads.map((x: any) => new PracticeFileUpload(x));

        if(state.practiceFileUploads.length == 0){
          addRecord();
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`処理に失敗しました。一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`処理に失敗しました。一覧に戻ります。`);
        }
        window.history.back();
      });

      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      addRecord,
      deleteRecord,
      update,
    };
  }
});

